import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface SEOProps {
  page: 'home' | 'calculator';
}

const SEO = ({ page }: SEOProps) => {
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    const title = t(`seo.${page}.title`);
    const description = t(`seo.${page}.description`);
    const keywords = t(`seo.${page}.keywords`);
    
    // Update document title
    document.title = title;
    
    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };
    
    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    
    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:locale', i18n.language === 'sv' ? 'sv_SE' : 'en_US', true);
    
    // Twitter Card tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    
  }, [t, i18n.language, page]);
  
  return null;
};

export default SEO;
